import { render, staticRenderFns } from "./eliminarEnlace.vue?vue&type=template&id=33073344&"
import script from "./eliminarEnlace.vue?vue&type=script&lang=js&"
export * from "./eliminarEnlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports